/**
 * Display formatters bound to Norwegian locale defaults.
 * All amounts assume NOK; vintages are 4-digit strings.
 */

const NB = 'nb-NO';
const TZ = 'Europe/Oslo';

export function formatPriceNok(value?: number | null): string {
  if (value == null || Number.isNaN(value)) return '—';
  return new Intl.NumberFormat(NB, { style: 'currency', currency: 'NOK', maximumFractionDigits: 0 }).format(value);
}

export function formatVolumeMl(value?: number | null): string {
  if (value == null || Number.isNaN(value)) return '';
  return value < 1
    ? `${Math.round(value * 1000)} ml`
    : `${value.toFixed(2).replace(/\.00$/, '')} L`;
}

export function formatAbv(value?: number | null): string {
  if (value == null || Number.isNaN(value)) return '';
  return `${value.toFixed(1).replace(/\.0$/, '')}%`;
}

export function formatDate(value?: string | Date | null): string {
  if (!value) return '—';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return new Intl.DateTimeFormat(NB, { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: TZ }).format(d);
}

export function formatNumber(value?: number | null): string {
  if (value == null || Number.isNaN(value)) return '—';
  return new Intl.NumberFormat(NB).format(value);
}

export function formatPercent(value?: number | null): string {
  if (value == null || Number.isNaN(value)) return '—';
  return `${new Intl.NumberFormat(NB, { maximumFractionDigits: 1 }).format(value)} %`;
}

export function truncate(text: string, max = 80): string {
  if (text.length <= max) return text;
  return text.slice(0, max - 1).trimEnd() + '…';
}
